import { Ban, FileSearch, ShieldCheck } from 'lucide-react';

import { Button } from '../../components/Button';
import type { WorkerProgressResponse } from '../../workers/protocol';

export interface CheckingScreenProps {
  readonly fileName: string;
  readonly progress: WorkerProgressResponse | null;
  readonly onCancel: () => void;
}

export function CheckingScreen({ fileName, progress, onCancel }: CheckingScreenProps) {
  const percent = progress?.percent ?? 4;
  return (
    <main className="grid min-h-[calc(100dvh-7rem)] place-items-center bg-slate-100 px-4 py-10">
      <section className="w-full max-w-xl rounded-xl border border-slate-300 bg-white p-6 shadow-[0_24px_70px_rgba(31,52,72,0.12)] sm:p-8">
        <span className="grid size-14 place-items-center rounded-lg bg-slate-800 text-white">
          <FileSearch aria-hidden="true" className="size-7" />
        </span>
        <h1 className="mt-6 text-2xl font-black tracking-tight text-slate-900">正在检查清单</h1>
        <p className="mt-2 truncate text-sm text-slate-600" title={fileName}>
          {fileName}
        </p>

        <div className="mt-8" aria-live="polite" aria-busy="true">
          <div className="flex items-center justify-between gap-4 text-sm">
            <span className="font-semibold text-slate-800">
              {progress?.message ?? '正在准备本地检查线程'}
            </span>
            <span className="font-mono font-bold text-slate-600">{percent}%</span>
          </div>
          <div className="mt-3 h-2 overflow-hidden rounded-full bg-slate-200">
            <div
              className="h-full rounded-full bg-orange-600 transition-[width] duration-300"
              style={{ width: `${String(percent)}%` }}
            />
          </div>
        </div>

        <div className="mt-6 flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-xs leading-5 text-emerald-900">
          <ShieldCheck aria-hidden="true" className="mt-0.5 size-5 shrink-0" />
          <p>解析和规则执行均在 Web Worker 中完成，文件内容不会上传。</p>
        </div>

        <Button
          className="mt-6 w-full"
          icon={<Ban aria-hidden="true" className="size-4" />}
          onClick={onCancel}
        >
          取消检查
        </Button>
      </section>
    </main>
  );
}
